import { Button, Icon, Text } from '@/components/atoms';
import { OTPInput } from '@/components/molecules';
import { FC, FormEvent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ResendOTPInterval from './ResendOTPInterval';

interface Props {
  onBackClick: () => void;
  onConfirmCode: (otpCode: string, cbError: () => void) => void;
  maskedPhoneNumber: string;
  onResendOTP: () => void;
}

export type OTPFields = {
  otpCode: string;
};

const OTP_LENGTH = 6;

const OTPForm: FC<Props> = ({
  onBackClick,
  onConfirmCode,
  maskedPhoneNumber,
  onResendOTP,
}) => {
  const [otpValue, setOTPValue] = useState('');

  const {
    formState: { errors },
    setError,
    clearErrors,
  } = useForm<OTPFields>({
    defaultValues: {
      otpCode: '',
    },
  });

  useEffect(() => {
    if (otpValue.length !== OTP_LENGTH) {
      clearErrors('otpCode');
    }
  }, [otpValue, clearErrors]);

  const handleOnSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const cbError = () => {
      setError('otpCode', { type: 'custom', message: 'Incorrect code' });
    };
    onConfirmCode(otpValue, cbError);
  };

  const checkDisabled = () => {
    if (otpValue?.length === 6 && !errors.otpCode) {
      return false;
    }
    return true;
  };

  const disabled = checkDisabled();

  return (
    <div className="flex flex-col gap-20 w-full">
      <div
        className="flex gap-4 cursor-pointer py-3 pr-3 pl-2"
        onClick={onBackClick}
      >
        <Icon name="chevronLeftNoSpacing" />
        <Text value="Back" />
      </div>
      <form onSubmit={handleOnSubmit} className="flex flex-col gap-md">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-4">
            <Text value="Enter OTP code" size="h1" />
            <Text
              value={`We sent it to ${maskedPhoneNumber}`}
              color="secondary"
            />
          </div>
          <div className="flex gap-10">
            <OTPInput
              value={otpValue}
              valueLength={OTP_LENGTH}
              onChange={setOTPValue}
              name="otpCode"
              errors={errors}
              clearErrors={clearErrors}
              showError={true}
            />
          </div>
          <Button disabled={disabled} type="submit" fullWidth>
            Continue
          </Button>
          <div className="flex gap-4 items-baseline">
            <Text
              value="Haven’t received code?"
              intent={'text'}
              color={'secondary'}
            ></Text>
            <ResendOTPInterval onResendOTP={onResendOTP} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default OTPForm;
